import React, { useContext, useEffect, useState } from 'react';

import { Field, FieldArray } from 'formik'
import { Switch } from '../../../../common/formik';

import {
    Grid,
    Button,
    Typography,
    Card,
    CardContent,
    CardHeader,
    Divider
} from '@material-ui/core';

import { 
    Select,
    FieldError
} from '../../../../common'

import { InvoiceAddressForm } from './InvoiceAddressForm';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames } from '../../../../../helpers'
import { defaultInvoiceAddress } from '../../../../../content';


import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
    addButton: {
        float: "right", 
        marginTop: theme.spacing(1)
    },
    removeButton: {
        float: "right", 
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1)
    }
}));

export const AdministrativeForm = (props) => {
    const classes = useStyles();

    const {
        state
    } = useContext(CustomerRequestContext);

    const { 
        values,
        isSavingRequest
     } = useContext(TabsContext);

    return (
        <Card className={classes.card}>
            <CardHeader title="Ship to party information" />
            <CardContent>
                <Grid container spacing={3}>
                    <Grid item xl={8} md={12} xs={12}>
                        <Field
                            label="Is the delivery address different from client's address?"
                            name="isInvoceAddressDifferentFromCustomer"
                            disabled={true/*isSavingRequest || props.disabled*/} //hardcoding for a Valerio Francione's request
                            component={Switch} 
                        />
                    </Grid>
                    {values.isInvoceAddressDifferentFromCustomer && (
                        <FieldArray 
                            name="invoiceAddresses"
                            render={arrayHelpers => {
                                return(
                                    <>
                                        {
                                            values.invoiceAddresses && values.invoiceAddresses.length > 0 &&
                                            values.invoiceAddresses.map((address, index) => {
                                                return(
                                                    <React.Fragment key={index}>
                                                        <Grid item xl={12} md={12} xs={12}>
                                                            <Typography variant="h6">
                                                                {`Invoice address ${index+1}`}
                                                            </Typography>
                                                        </Grid>
                                                        <Grid item xl={12} md={12} xs={12}>
                                                            <InvoiceAddressForm 
                                                                formSuffixName={`invoiceAddresses[${index}]`} 
                                                                suffixIndex={index}
                                                                disabled={props.disabled} />
                                                        </Grid>
                                                        <Divider style={{ width: "100%" }} />
                                                        <Grid item xl={12} md={12} xs={12}>
                                                            {index === values.invoiceAddresses.length - 1
                                                                && values.invoiceAddresses.length < 6 
                                                                && !props.disabled && (
                                                                <Button
                                                                    className={classes.addButton}
                                                                    variant="contained"
                                                                    color="primary"
                                                                    disabled={isSavingRequest || props.disabled}
                                                                    onClick={() => arrayHelpers.push({ ...defaultInvoiceAddress })}>
                                                                    Add another
                                                                </Button>
                                                            )}
                                                            {index !== 0 
                                                                &&!props.disabled && (
                                                                <Button
                                                                    className={classes.removeButton}
                                                                    variant="contained"
                                                                    color="secondary"
                                                                    disabled={isSavingRequest || props.disabled}
                                                                    onClick={() => arrayHelpers.remove(index)}>
                                                                    Remove this
                                                                </Button>
                                                            )}
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })
                                        }
                                    </>
                                );
                            }}
                        />
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
}